import script from './component-lib.esm3.js';
export { ButtonProps } from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.buttonTag, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-button",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "type": _vm.buttonType,
      "disabled": _vm.disabled || _vm.loading
    }
  }, 'component', _vm.$attrs, false), Object.assign({}, _vm.$listeners, {
    click: _vm.handleClick
  })), [_c('span', {
    staticClass: "v-button__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.loading ? _c('span', {
    staticClass: "v-button__loader"
  }, [_c('CircularLoader', {
    attrs: {
      "color": "current",
      "size": "1.75em"
    }
  })], 1) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-f0a7fffc_0", {
    source: ".v-button[data-v-f0a7fffc]{align-items:center;background:var(--c-bg-color);border:2px solid var(--c-bg-color);border-radius:var(--g-border-radius-standard);color:var(--c-color);cursor:pointer;display:inline-flex;font-family:var(--g-font-button-family);font-size:1rem;font-weight:var(--g-button-font-weight);letter-spacing:var(--g-button-letter-spacing);line-height:normal;padding:.5em 1.25em;position:relative;overflow:hidden;justify-content:center;text-align:center;text-decoration:none;text-transform:var(--c-text-transform);transition:all var(--g-transition-speed)}.v-button[data-v-f0a7fffc]:focus,.v-button[data-v-f0a7fffc]:hover{background:var(--c-bg-color-active);color:var(--c-color)}.v-button[data-v-f0a7fffc]:active{transform:scale(.98)}.v-button[data-v-f0a7fffc]:disabled:not(.v-button--loading),.v-button[disabled][data-v-f0a7fffc]:not(.v-button--loading){background-color:var(--c-disabled-bg-color);border-color:var(--c-disabled-bg-color);color:var(--c-disabled-color);opacity:.75;pointer-events:none;transform:none}.v-button--xsmall[data-v-f0a7fffc]{font-size:.75rem}.v-button--small[data-v-f0a7fffc]{font-size:.875rem}.v-button--large[data-v-f0a7fffc]{font-size:1.25rem}.v-button--outline[data-v-f0a7fffc]{background:0 0;border-color:var(--c-bg-color);color:var(--c-bg-color)}.v-button--outline[data-v-f0a7fffc]:focus,.v-button--outline[data-v-f0a7fffc]:hover{background:var(--c-bg-color);color:var(--c-color)}.v-button--hard-shadow[data-v-f0a7fffc]{box-shadow:4px 4px 0 var(--c-shadow-color);transition:none}.v-button--hard-shadow[data-v-f0a7fffc]:focus,.v-button--hard-shadow[data-v-f0a7fffc]:hover{box-shadow:2px 2px 0 var(--c-shadow-color);transform:translate(2px,2px);background:var(--c-bg-color)}.v-button--hard-shadow[data-v-f0a7fffc]:active{box-shadow:0 0 0 var(--c-shadow-color);transform:translate(4px,4px)}.v-button--hollow[data-v-f0a7fffc]:focus,.v-button--hollow[data-v-f0a7fffc]:hover{background:0 0;color:var(--c-bg-color)}.v-button--flat[data-v-f0a7fffc]{border:none;font-size:.875rem;font-weight:700;letter-spacing:0;padding:.45em 1em;margin:.375rem .5rem;min-width:4.5rem;text-transform:uppercase}.v-button--loading[data-v-f0a7fffc]{cursor:default;pointer-events:none}.v-button--loading .v-button__content[data-v-f0a7fffc]{opacity:0}.v-button--block[data-v-f0a7fffc]{display:flex;width:100%}.v-button--block .v-button__content[data-v-f0a7fffc]{width:100%}.v-button--circular[data-v-f0a7fffc]{border-radius:var(--g-border-radius-circular)}.v-button__content[data-v-f0a7fffc]{align-items:center;display:flex;justify-content:center}.v-button__loader[data-v-f0a7fffc]{background:var(--c-bg-color);align-items:center;display:flex;left:0;height:100%;justify-content:center;position:absolute;top:0;width:100%}.v-button--outline .v-button__loader[data-v-f0a7fffc]{background:var(--c-color);color:var(--c-bg-color)}.v-button--flat .v-button__loader[data-v-f0a7fffc]{background:var(--c-bg-color-active)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-f0a7fffc";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Button = __vue_component__;
export { Button as default };